import React, { useEffect, useCallback, useState } from 'react';
import { Col, Label, Row, Badge } from 'reactstrap';
import { EN, ES } from '../../Etiquetas/Labels';
import { FormEnglish, FormEsp } from '../../Form';
import ControlledAccordions from './Components/Accordion';
import { ModelCreateTicket } from '../CreateTicket/model';
import { Link, useParams } from "react-router-dom";
import ModalCloseTicket from './Components/closeticket';
import Axios from "axios";
import ContentWrapper from '../../Components/ContenWraper/ContentWrapper'
import { STATUS_COLORS } from '../../config/serviceDeskConfigs';

import { Services } from '../../Services';
import { DefaultLoader } from '../../config/defaultLoader';


function TicketDetailsComponent(props) {
  const { CustomLoader = DefaultLoader } = props;

  const { id } = useParams();
  const [modelDetail] = React.useState({ ...ModelCreateTicket() });
  const [Labels, setLabels] = useState(EN);
  const [Form, setForm] = React.useState(FormEnglish);
  const [validate, setValidate] = React.useState(false);
  const [Ticket, setTicket] = useState([{ TicketNumber: '', CreatedBy: '', Subjet: '', Status: '', Type: '', CreationDate: '', CloseDate: '' },]);
  const [closed, setClosed] = useState(false);
  const [ActiveLoader, setActiveLoader] = React.useState(false)
  const [idProject, setIdProject] = useState(0);
  const [newComment, setNewComment] = React.useState('');
  const [disabledButton, setDisabledButton] = React.useState(true);
  const [tz] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone)


  const GetTicketId = useCallback(async (idProject) => {
    try {
      let body = {
        idProject: idProject,
        timezone: tz
      }
      let Ticket = await Axios.post(`${Services.TICKETS.path}Ticket/ticketid/${id}`, { timezone: tz });
      let resultCatalogos = await Axios.post(`${Services.TICKETS.path}catalogos/catalogos/`, body);
      resultCatalogos.data.data.dataCatReasonsCloses.map((e) => {
        modelDetail.Catalogs.ReasonsCloses.push({ 'key': e.ReasonCloseId, 'value': e.ReasonCloseId, 'text': e.ReasonClose });
        return e;
      });
      if (Ticket.data.data[0].CatStatusId === 3 || Ticket.data.data[0].CatStatusId === 4) {
        setClosed(true);
      } else {
        setClosed(false);
      }
      setTicket(Ticket.data.data);
      setActiveLoader(true)
    } catch (error) {
      console.log('The Error-->', error);
    }
  }, [idProject, tz, id]);


  function CancelTicket() {
    let body = {
      comm: newComment,
      ByHelpDesk: 0,
      ByUser: 1
    }
    Axios.put(`${Services.TICKETS.path}Ticket/cancelticket/${id}`, body)
      .then((response) => {
        GetTicketId()
      })
      .catch((error) => {
        console.warn(error);
      });
  }

  function handleChange(evt, data) {
    setNewComment(data.value);
    if (data.value) {
      setDisabledButton(false)
    } else {
      setDisabledButton(true)
    }
  }

  useEffect(() => {
    setIdProject(props.ProjectId)
    setLabels(props.lng === 'EN' ? EN : ES)
    setForm(props.lng === 'EN' ? FormEnglish : FormEsp)
    setValidate(props.lng === 'EN' ? true : false)
    GetTicketId(props.ProjectId);
  }, [props]);

  return (
    <ContentWrapper>

      <CustomLoader hidden={ActiveLoader} />

      {/* Header personalizable */}
      {props.customHeader ? (
        props.customHeader
      ) : (
        <div className="content-heading">
          <div className={props.style?.titleModule || ''}>
            <i className={Labels.header.icon} />
            <b>{Labels.header.title}</b>
          </div>
        </div>
      )}
      <div className='row'>
        <div className='col-xs-8 col-md-9 col-lg-10'>
          <div className='row'>
            <div className='col-xs-12 col-md-4 col-lg-3'>
              <Link
                to={"/service-desk"}
                className="back-button-sd"
                style={{ textDecoration: 'none' }}
              >
                <i className='fas fa-chevron-left' />
                {`Ticket ${Ticket[0].TicketNumber}`}
              </Link>
              <Badge
                style={{
                  width: '100%',
                  background: STATUS_COLORS[props.ProjectId] || STATUS_COLORS.default,
                  fontSize: '14px',
                  // padding: '0.3em'
                }}
                pill
              >{Ticket[0].Status}</Badge>
            </div>
            <div className='col-xs-12 col-md-8 col-lg-9 '>
              <p className='title-ticket'>{` ${Ticket[0].Subjet}`}</p>
              <p>
                {closed ? `${Labels.details.lbl_close} ` : `${Labels.details.last_update} `}
                {`${Ticket[0].updatedate} `}
              </p>

            </div>
          </div>
        </div>
        <div className='col-xs-4 col-md-3 col-lg-2 d-flex align-items-center' >
          <ModalCloseTicket
            Ticket={Ticket[0]}
            catalogos={modelDetail.Catalogs}
            labels={Labels}
            CancelTicket={CancelTicket}
            onChange={handleChange}
            idProject={props.ProjectId}
            disabledButton={disabledButton}
          />
        </div>
      </div>
      <ControlledAccordions dataTikets={Ticket[0]} id={id} Closed={closed} Labels={Labels} Form={Form} validate={validate} GetTicketId={GetTicketId} idProject={props.ProjectId} class={props.style} />
    </ContentWrapper>
  );
}

export default TicketDetailsComponent;